import Command from "@ckeditor/ckeditor5-core/src/command";
import { CkeditorConstants } from "../../src/utils/ckeditorconstants.js";
import randomUUIDGenerator from '../../src/utils/randomUUIDGenerator.js';
import { getSelectedContent } from "../../src/utils/subtemplateutils"
import { checkIfSelectionIsInsertion } from "../../src/utils";

const {
  linksTo,
  localStorageItem: { baseHrefForLinkPlugin },
  htmlElement: { LINK_SPAN },
  helperAttributes : { DATA_CKE_TOOLTIP_TEXT, DATA_CKE_TOOLTIP_CLASS, DATA_SOURCE_ID },
  tooltip : { FRAGMENT_TARGET_TOOLTIP, FRAGMENT_TARGET_TOOLTIP_CLASS },
  attributeLinkOtherDocument,
  PLUGINS: { TRACK_CHANGES,TRACKCHANGE_EDITING },
  COMMANDS: { CMD_TRACK_CHANGES }
} = CkeditorConstants;

export default class InsertFragmentLinkCommand extends Command {
  execute({ value }) {
    const { editor } = this;
    const { model } = editor;
    const { selection } = model.document;
    let isTextMarkedInGreen = checkIfSelectionIsInsertion(editor);
    model.change((writer) => {
      const rootElement = editor.editing.view.domRoots.get('main');
      const baseHref = this.editor.baseHrefForLinkPlugin;
      const idForFragmentLink = randomUUIDGenerator();
      const resourceId = value.resource.split('#')[1];
      const fragmentLinkSpan = writer.createElement(LINK_SPAN, {
        id: idForFragmentLink,
        about: `${baseHref}#${idForFragmentLink}`,
        rel: linksTo,
        typeof: attributeLinkOtherDocument,
        class: 'ref',
        resource: `${baseHref}#${resourceId}`,
        'data-fragment': true
      });
      const resourceElement = rootElement.querySelector(`[id='${resourceId}']`);
      if (resourceElement.hasAttribute(DATA_SOURCE_ID)) {
        const idsOfSource = resourceElement.getAttribute(DATA_SOURCE_ID) + ',' + idForFragmentLink;
        resourceElement.setAttribute(DATA_SOURCE_ID, idsOfSource);
      } else {
        resourceElement.setAttribute(DATA_SOURCE_ID, idForFragmentLink);
      }
      resourceElement.setAttribute(DATA_CKE_TOOLTIP_TEXT, FRAGMENT_TARGET_TOOLTIP);
      resourceElement.setAttribute('data-cke-tooltip-position','n');
      resourceElement.setAttribute(DATA_CKE_TOOLTIP_CLASS, FRAGMENT_TARGET_TOOLTIP_CLASS);
      const selectedHtmlString = getSelectedContent(editor);
      const viewFragment = this.editor.data.processor.toView(selectedHtmlString);
      const modelFragment = this.editor.data.toModel(viewFragment);
      for (let item of modelFragment.getChildren()) {
        writer.unwrap(item);
      }
      writer.remove(selection.getFirstRange());
      writer.append(modelFragment, fragmentLinkSpan);
      writer.insert(fragmentLinkSpan, selection.focus);
      if (this.editor.commands.get(CMD_TRACK_CHANGES).value && this.editor.plugins.get(TRACK_CHANGES).isEnabled) {
        const rangeOnFragmentLinkSpan = writer.createRangeOn(fragmentLinkSpan);
        const trackChangesEditing = editor.plugins.get(TRACKCHANGE_EDITING);
        trackChangesEditing.markInsertion(rangeOnFragmentLinkSpan, '', {
          commandParams: {
            isTextMarkedInGreen : isTextMarkedInGreen
          }
        });      
      }
      this.editor.focus();
    });
  }
}
